import { System } from '@ecs/System';
import { HealthDisplay } from '@components/HealthDisplay';
import { Health } from '@components/Health';
import { Tag } from '@components/Tag';

export class HealthDisplayLogicSystem extends System {
  update(_deltaTime: number): void {
    // Update health display for all entities with health
    const entities = this.getEntitiesWithComponents(Health, HealthDisplay);
    
    for (const entity of entities) {
      const health = entity.getComponent(Health)!;
      const healthDisplay = entity.getComponent(HealthDisplay)!;
      const tag = entity.getComponent(Tag);
      
      // Players always show health; enemies only once they've taken damage
      healthDisplay.showHealthBar = tag?.value === 'player' ||
        (tag?.value === 'enemy' && health.current < health.max);
      
      if (healthDisplay.showHealthBar) {
        // Calculate health percentage
        healthDisplay.healthPercentage = health.current / health.max;
        
        // Set color based on health percentage
        if (healthDisplay.healthPercentage > 0.66) {
          healthDisplay.barColor = '#00ff00'; // Green
        } else if (healthDisplay.healthPercentage > 0.33) {
          healthDisplay.barColor = '#ffff00'; // Yellow
        } else {
          healthDisplay.barColor = '#ff0000'; // Red
        }
      }
    }
  }
}
